import { HeadlineText, Space } from "@classdojo/web/nessie";
import { useMemo } from "react";
import BedtimeList from "./BedtimeList";
import FixedHeaderScroller from "./BeyondToolkit/FixedHeaderScroller";

type ToolkitMenuProps = {
  isPremiumUnlocked: boolean;
  variant: string | string[];
};

function ToolkitMenu({ isPremiumUnlocked, variant }: ToolkitMenuProps) {
  const lockedUrl = useMemo(() => {
    return `/beyondToolkit?isPremiumUnlocked=${isPremiumUnlocked}&variant=${variant.toString()}`;
  }, [isPremiumUnlocked, variant]);

  return (
    <FixedHeaderScroller
      headerBackground="dt_background_primary"
      header={
        <div sx={{ textAlign: "center", margin: "dt_s", position: "relative" }}>
          <HeadlineText as="h2">Bedtime</HeadlineText>
        </div>
      }
      contentBackground="dt_background_primary"
    >
      <div
        sx={{ display: "flex", alignItems: "center", flexDirection: "column", padding: "dt_s", position: "relative" }}
      >
        <BedtimeList isPremiumUnlocked={isPremiumUnlocked} lockedUrl={lockedUrl} />
      </div>
      <Space size="l" />
    </FixedHeaderScroller>
  );
}

export default ToolkitMenu;
